<template>
    <v-container fluid>
        <v-layout>
            <v-flex>
                <div class="display-3 text-xs-center">Dashboard</div>

                <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                        <template v-for="(w,index) in widgets">
                            <v-flex xs12
                                    :sm3="w.comp === 'presupuestoIr'"
                                    :sm6="w.comp === 'actualizacionesSist'"
                                    :sm5="w.comp === 'misPresupuestos'">
                                <component v-bind:is="w.comp" class="animated fadeIn">
                                    <div slot="opciones">
                                        <v-btn color="primary" small dark icon flat @click="orden(index,'s')">
                                            <v-icon>keyboard_arrow_down</v-icon>
                                        </v-btn>
                                        <v-btn color="primary" small dark icon flat @click="orden(index,'b')">
                                            <v-icon>keyboard_arrow_up</v-icon>
                                        </v-btn>
                                    </div>
                                </component>
                            </v-flex>
                        </template>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm6>
                            <actualizaciones-sist></actualizaciones-sist>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
        <v-menu
                left
                v-model="showWidgets"
                fixed
                style="max-width: 600px"
                :close-on-content-click="false"
        >
            <v-btn
                    :loading="loading"
                    slot="activator"
                    fab
                    color="blue accent-2"
                    bottom
                    right
                    fixed
                    dark
            >
                <v-icon>build</v-icon>
            </v-btn>
            <v-card>
                <v-card-title>Activar Widgets</v-card-title>
                <v-divider></v-divider>
                <v-list>
                    <template v-for="(w,index) in widList">
                        <v-list-tile>
                            <v-list-tile-action>
                                <v-switch v-model="w.activo" color="purple" @change="widgetGuardar(true)"></v-switch>
                            </v-list-tile-action>
                            <v-list-tile-title>{{ w.tit }}</v-list-tile-title>
                        </v-list-tile>
                    </template>
                    <v-list-tile href="./app.apk">
                        <v-list-tile-title>Descargar app</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-card>

        </v-menu>
    </v-container>
</template>
<script>
    import {mapGetters} from 'vuex';
    import actualizacionesSist from '../components/dashboard/ActualizacionesSistema';
    import misPresupuestos from '../components/dashboard/misPresupuestos';
    import presupuestoIr from '../components/dashboard/presupuestoIr';
    import kanban from '../components/dashboard/Kanban';
    import solicitudesDesc from '../components/dashboard/SolicitudesDesc';
    import solicitudesCalidad from '../components/dashboard/SolicitudesCalidad';

    export default {
        components: {misPresupuestos, presupuestoIr, kanban, solicitudesDesc, actualizacionesSist,solicitudesCalidad},
        data() {
            return {
                grid: {},
                showWidgets: false,
                loading: false,
                widList: [
                    // {tit: 'Actualizaciones del sistema', comp: 'actualizacionesSist', activo: false},
                    {tit: 'Mis Presupuestos', comp: 'misPresupuestos', activo: false},
                    {tit: 'Ir a presupuesto', comp: 'presupuestoIr', activo: false},
                    {tit: 'Kanban', comp: 'kanban', activo: false},
                    {tit: 'Solicitudes de descuento', comp: 'solicitudesDesc', activo: false},
                    {tit: 'Solicitudes de calidad', comp: 'solicitudesCalidad', activo: false},
                ],
                widgets: [],
                commits: [],
            }
        },
        computed: {
            ...mapGetters('auth', ['userName']),
        },
        mounted() {
            this.widgetMostrar();
        },
        methods: {
            orden(from, oper) {
                let total = this.widgets.length;
                let to = (oper === 's') ? from + 1 : from - 1;

                if (oper === 's' && to === total) {
                    return false;
                }

                if (oper === 'b' && to === -1) {
                    return false;
                }
                let el = this.widgets[from];
                this.widgets.splice(from, 1);
                this.widgets.splice(to, 0, el);
                this.widgetGuardar(false)
            },
            widgetMostrar() {
                this.loading = true;
                this.$http.post('widgets/mostrar')
                    .then(r => {
                        if (r.data.length > 0) {
                            r.data.forEach(w => {
                                let indx = this.widList.findIndex(x => x.comp === w);
                                this.widList[indx].activo = true;
                                this.widgets.push(this.widList[indx])
                            });
                        }
                        this.loading = false;
                    })
            },
            widgetGuardar(orden) {
                this.loading = true;
                let widgets = this.widList.filter(r => r.activo === true).map(r => r.comp);
                this.$http.post('widgets/guardar', {widgets: widgets})
                    .then(r => {
                        if (orden) {
                            this.widgets = [];
                            widgets.forEach(w => {
                                let indx = this.widList.findIndex(x => x.comp === w);
                                this.widgets.push(this.widList[indx])
                            });
                        }
                        this.loading = false;
                    })
            }
        }
    }
</script>




// WEBPACK FOOTER //
// resources/assets/js/pages/dashboard.vue